import React from "react";
import { Link } from "react-router-dom";

const Services = () => {
  const services = [
    {
      icon: "fa-house",
      name: "House Cleaning",
      desc: "Deep cleaning, dusting, and sanitizing for every corner of your home.",
      image:
        "https://images.unsplash.com/photo-1600220379009-0bce7de911c1?auto=format&fit=crop&w=900&q=60",
    },
    {
      icon: "fa-building",
      name: "Office Cleaning",
      desc: "Daily, weekly, or monthly maintenance for a spotless workspace.",
      image:
        "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=900&q=60",
    },
    {
      icon: "fa-car",
      name: "Car Wash",
      desc: "Interior and exterior car cleaning with eco-friendly products.",
      image:
        "https://images.unsplash.com/photo-1618354691373-d851c5c1e828?auto=format&fit=crop&w=900&q=60",
    },
    {
      icon: "fa-spray-can",
      name: "Window Cleaning",
      desc: "Crystal-clear windows for homes and offices, streak-free every time.",
      image:
        "https://images.unsplash.com/photo-1598300180391-7a6be601d6c1?auto=format&fit=crop&w=900&q=60",
    },
    {
      icon: "fa-broom",
      name: "Floor Polishing",
      desc: "Shiny floors with premium waxing and polishing treatment.",
      image:
        "https://images.unsplash.com/photo-1621905251918-38596566c7e3?auto=format&fit=crop&w=900&q=60",
    },
    {
      icon: "fa-bug",
      name: "Pest Control",
      desc: "Safe and effective pest management for homes and offices.",
      image:
        "https://images.unsplash.com/photo-1606756790138-261c6ac6935e?auto=format&fit=crop&w=900&q=60",
    },
  ];

  const steps = [
    {
      icon: "fa-magnifying-glass",
      title: "Browse Services",
      desc: "Explore a variety of cleaning and maintenance categories.",
    },
    {
      icon: "fa-user-check",
      title: "Select a Provider",
      desc: "View ratings, compare prices, and choose the best professional.",
    },
    {
      icon: "fa-calendar-check",
      title: "Book Instantly",
      desc: "Confirm your booking online and track your cleaner in real time.",
    },
    {
      icon: "fa-smile",
      title: "Enjoy Clean Spaces",
      desc: "Sit back and relax while we handle the cleaning professionally.",
    },
  ];

  return (
    <>
      {/* HERO BANNER */}
      <section className="services-hero">
        <div className="hero-content">
          <h1>Our Professional Services</h1>
          <p>
            Cleanering offers reliable cleaning and maintenance solutions for
            homes, offices, and vehicles — handled by trained professionals.
          </p>
        </div>
      </section>

      {/* SERVICE GRID */}
      <section className="services-section">
        <h2>Choose What You Need</h2>
        <div className="service-grid">
          {services.map((s, i) => (
            <div className="service-card" key={i}>
              <img src={s.image} alt={s.name} />
              <div className="service-info">
                <i className={`fa-solid ${s.icon}`}></i>
                <h3>{s.name}</h3>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="steps">
        <h2>How It Works</h2>
        <div className="steps-grid">
          {steps.map((step, i) => (
            <div className="step-card" key={i}>
              <i className={`fa-solid ${step.icon}`}></i>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta">
        <h2>Need a Cleaner Today?</h2>
        <p>
          Book professional cleaning services from the comfort of your home.
        </p>
        <div className="cta-buttons">
          <Link to="/" className="btn primary">
            Go Back Home
          </Link>
          <Link to="/" className="btn secondary">
            Contact Support
          </Link>
        </div>
      </section>
    </>
  );
};

export default Services;